import { render, staticRenderFns } from "./CertificationInventoryList.vue?vue&type=template&id=27970183&scoped=true"
import script from "./CertificationInventoryList.vue?vue&type=script&lang=js"
export * from "./CertificationInventoryList.vue?vue&type=script&lang=js"
import style0 from "./CertificationInventoryList.vue?vue&type=style&index=0&id=27970183&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27970183",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27970183')) {
      api.createRecord('27970183', component.options)
    } else {
      api.reload('27970183', component.options)
    }
    module.hot.accept("./CertificationInventoryList.vue?vue&type=template&id=27970183&scoped=true", function () {
      api.rerender('27970183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectOverview/CertificationInventoryList.vue"
export default component.exports